import { cn } from '../lib/cn';

/**
 * Заглушка на время загрузки.
 *
 * Скрыта от программ чтения с экрана: озвучивать пустые блоки бессмысленно,
 * о загрузке сообщает `aria-busy` контейнера.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div aria-hidden="true" className={cn('animate-pulse rounded-md bg-[var(--surface-muted)]', className)} />
  );
}

export function SkeletonCard() {
  return (
    <div className="surface-card space-y-3 p-5 sm:p-6" aria-busy="true">
      <Skeleton className="h-5 w-2/5" />
      <Skeleton className="h-9 w-1/3" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-4/5" />
    </div>
  );
}
